(() => {
  'use strict';
  const ELEMENT_NAME = 's-human-years-calculator';
  if (customElements.get(ELEMENT_NAME)) return;
  class HumanYearsCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      const root = this;


          var DOG_ANCHORS = {
            small:  [[0,0],[0.5,10],[1,15],[2,24],[3,28],[4,32],[5,36],[6,40],[7,44],[8,48],[9,52],[10,56],[11,60],[12,64],[13,68],[14,72],[15,76],[16,80]],
            medium: [[0,0],[0.5,10],[1,15],[2,24],[3,28],[4,32],[5,36],[6,42],[7,47],[8,51],[9,56],[10,60],[11,65],[12,69],[13,74],[14,78],[15,83],[16,87]],
            large:  [[0,0],[0.5,9],[1,15],[2,24],[3,28],[4,32],[5,36],[6,45],[7,50],[8,55],[9,61],[10,66],[11,72],[12,77],[13,82],[14,88],[15,93],[16,99]],
            giant:  [[0,0],[0.5,8],[1,12],[2,22],[3,31],[4,38],[5,45],[6,49],[7,56],[8,64],[9,71],[10,78],[11,86],[12,93],[13,101],[14,108],[15,115],[16,123]]
          };

          var CAT_ANCHORS = [[0,0],[0.5,10],[1,15],[2,24],[3,28],[4,32],[5,36],[6,40],[7,44],[8,48],[9,52],[10,56],[11,60],[12,64],[13,68],[14,72],[15,76],[16,80],[17,84],[18,88],[19,92],[20,96],[25,116]];

          var BREEDS = [
            ["Australian Cattle Dog","medium"],
            ["Australian Kelpie","medium"],
            ["Basset Hound","medium"],
            ["Beagle","medium"],
            ["Bernese Mountain Dog","giant"],
            ["Bichon Frise","small"],
            ["Border Collie","medium"],
            ["Boston Terrier","small"],
            ["Boxer","large"],
            ["Bullmastiff","giant"],
            ["Cavalier King Charles Spaniel","small"],
            ["Chihuahua","small"],
            ["Cocker Spaniel","medium"],
            ["Collie, Rough","large"],
            ["Dachshund, Miniature","small"],
            ["Dachshund, Standard","medium"],
            ["Dalmatian","large"],
            ["Doberman Pinscher","large"],
            ["English Bulldog","medium"],
            ["English Springer Spaniel","medium"],
            ["French Bulldog","medium"],
            ["German Shepherd Dog","large"],
            ["German Shorthaired Pointer","large"],
            ["Golden Retriever","large"],
            ["Great Dane","giant"],
            ["Great Pyrenees","giant"],
            ["Irish Wolfhound","giant"],
            ["Jack Russell Terrier","small"],
            ["Labrador Retriever","large"],
            ["Leonberger","giant"],
            ["Maltese","small"],
            ["Mastiff","giant"],
            ["Miniature Schnauzer","small"],
            ["Newfoundland","giant"],
            ["Pomeranian","small"],
            ["Poodle, Miniature or Toy","small"],
            ["Poodle, Standard","large"],
            ["Pug","small"],
            ["Rhodesian Ridgeback","large"],
            ["Rottweiler","giant"],
            ["Saint Bernard","giant"],
            ["Shetland Sheepdog","medium"],
            ["Shih Tzu","small"],
            ["Siberian Husky","large"],
            ["Staffordshire Bull Terrier","medium"],
            ["Vizsla","large"],
            ["Weimaraner","large"],
            ["West Highland White Terrier","small"],
            ["Whippet","medium"],
            ["Yorkshire Terrier","small"]
          ];

          var SIZE_LABELS = {
            small: "Small",
            medium: "Medium",
            large: "Large",
            giant: "Giant"
          };

          var SENIOR_GUIDE = {
            small: 11,
            medium: 10,
            large: 8,
            giant: 7
          };

          var PUPPY_END = {
            small: 0.75,
            medium: 1,
            large: 1.25,
            giant: 1.5
          };

          var state = {
            species: "dog",
            unit: "kg",
            hasResult: false,
            resultSummary: ""
          };

          var form = root.querySelector("#age-form");
          var speciesButtons = Array.prototype.slice.call(root.querySelectorAll("[data-species]"));
          var unitButtons = Array.prototype.slice.call(root.querySelectorAll("[data-unit]"));
          var dogFields = root.querySelector("#dog-fields");
          var breedSelect = root.querySelector("#breed");
          var sizeSelect = root.querySelector("#dog-size");
          var weightInput = root.querySelector("#adult-weight");
          var yearsInput = root.querySelector("#age-years");
          var monthsInput = root.querySelector("#age-months");
          var errorBox = root.querySelector("#form-error");
          var results = root.querySelector("#results");
          var dirtyBox = root.querySelector("#results-dirty");
          var actionStatus = root.querySelector("#action-status");
          var resultActionButtons = Array.prototype.slice.call(root.querySelectorAll(".result-action"));
          var personaliseToggle = root.querySelector("#personalise-toggle");
          var personalisePanel = root.querySelector("#personalise-panel");
          var personaliseSymbol = root.querySelector("#personalise-symbol");

          function addBreedOptions() {
            BREEDS.forEach(function (breed) {
              var option = document.createElement("option");
              option.value = breed[0];
              option.dataset.size = breed[1];
              option.textContent = breed[0];
              breedSelect.appendChild(option);
            });
          }

          function setSpecies(species, shouldMarkDirty) {
            state.species = species;
            speciesButtons.forEach(function (button) {
              button.setAttribute("aria-pressed", String(button.dataset.species === species));
            });
            dogFields.hidden = species !== "dog";
            root.querySelectorAll("[data-dog-only]").forEach(function (element) {
              element.hidden = species !== "dog";
              if (element.hidden) {
                var input = element.querySelector("input");
                if (input) {
                  input.checked = false;
                }
              }
            });
            root.querySelectorAll("[data-cat-only]").forEach(function (element) {
              element.hidden = species !== "cat";
              if (element.hidden) {
                var input = element.querySelector("input");
                if (input) {
                  input.checked = false;
                }
              }
            });
            yearsInput.max = species === "dog" ? "20" : "25";
            if (shouldMarkDirty) {
              markDirty();
            }
          }

          function setUnit(unit, convertValue) {
            if (unit === state.unit) {
              return;
            }
            var value = Number(weightInput.value);
            if (convertValue && Number.isFinite(value) && value > 0) {
              value = unit === "lb" ? value * 2.2046226218 : value / 2.2046226218;
              weightInput.value = String(Math.round(value * 10) / 10);
            }
            state.unit = unit;
            unitButtons.forEach(function (button) {
              button.setAttribute("aria-pressed", String(button.dataset.unit === unit));
            });
            weightInput.max = unit === "kg" ? "250" : "550";
            weightInput.placeholder = unit === "kg" ? "e.g. 28" : "e.g. 62";
            markDirty();
          }

          function weightToKg(value) {
            return state.unit === "lb" ? value / 2.2046226218 : value;
          }

          function sizeFromWeight(kg) {
            if (kg <= 9.07) {
              return "small";
            }
            if (kg <= 22.68) {
              return "medium";
            }
            if (kg <= 40.82) {
              return "large";
            }
            return "giant";
          }

          function interpolate(anchors, age) {
            if (age <= 0) {
              return 0;
            }
            var finalIndex = anchors.length - 1;
            if (age >= anchors[finalIndex][0]) {
              var previous = anchors[finalIndex - 1];
              var final = anchors[finalIndex];
              var finalSlope = (final[1] - previous[1]) / (final[0] - previous[0]);
              return final[1] + finalSlope * (age - final[0]);
            }
            for (var index = 1; index < anchors.length; index += 1) {
              if (age <= anchors[index][0]) {
                var start = anchors[index - 1];
                var end = anchors[index];
                var fraction = (age - start[0]) / (end[0] - start[0]);
                return start[1] + fraction * (end[1] - start[1]);
              }
            }
            return anchors[finalIndex][1];
          }

          function getLifeStage(age, size) {
            if (state.species === "cat") {
              if (age < 1) {
                return { name: "Kitten", key: "young" };
              }
              if (age < 7) {
                return { name: "Young adult", key: "youngAdult" };
              }
              if (age < 10) {
                return { name: "Mature adult", key: "mature" };
              }
              return { name: "Senior", key: "senior" };
            }

            if (age < PUPPY_END[size]) {
              return { name: "Puppy", key: "young" };
            }
            if (age < 4) {
              return { name: "Young adult", key: "youngAdult" };
            }
            if (age < SENIOR_GUIDE[size]) {
              return { name: "Mature adult", key: "mature" };
            }
            return { name: "Senior", key: "senior" };
          }

          function readWholeNumber(input, fallback) {
            var raw = input.value.trim();
            if (raw === "") {
              return fallback;
            }
            var number = Number(raw);
            return Number.isInteger(number) ? number : NaN;
          }

          function validateInputs() {
            var years = readWholeNumber(yearsInput, 0);
            var months = readWholeNumber(monthsInput, 0);
            var maxYears = state.species === "dog" ? 20 : 25;

            if (!Number.isFinite(years) || years < 0 || years > maxYears) {
              return { error: "Enter a whole number of years from 0 to " + maxYears + ".", field: yearsInput };
            }
            if (!Number.isFinite(months) || months < 0 || months > 11) {
              return { error: "Enter extra months as a whole number from 0 to 11.", field: monthsInput };
            }
            if (years === 0 && months === 0) {
              return { error: "Enter your pet’s age. For a pet under one year, enter 0 years and their age in months.", field: yearsInput };
            }

            var size = null;
            var weight = null;
            var weightRaw = weightInput.value.trim();

            if (state.species === "dog") {
              if (weightRaw !== "") {
                weight = Number(weightRaw);
                var weightMax = state.unit === "kg" ? 250 : 550;
                if (!Number.isFinite(weight) || weight <= 0 || weight > weightMax) {
                  return { error: "Check the expected adult weight. Enter a value above 0 and no more than " + weightMax + " " + state.unit + ".", field: weightInput };
                }
              }

              size = sizeSelect.value;
              if (!size && weight !== null) {
                size = sizeFromWeight(weightToKg(weight));
                sizeSelect.value = size;
              }
              if (!size) {
                return { error: "Choose your dog’s expected healthy adult size, or enter an expected healthy adult weight so the calculator can suggest one.", field: sizeSelect };
              }
            }

            return {
              years: years,
              months: months,
              age: years + months / 12,
              size: size,
              weight: weight
            };
          }

          function showError(message, field) {
            errorBox.textContent = message;
            errorBox.hidden = false;
            if (field) {
              field.setAttribute("aria-invalid", "true");
              field.setAttribute("aria-errormessage", "form-error");
              field.focus();
            } else {
              errorBox.focus();
            }
          }

          function clearError() {
            errorBox.textContent = "";
            errorBox.hidden = true;
            form.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
              field.removeAttribute("aria-invalid");
              field.removeAttribute("aria-errormessage");
            });
          }

          function formatAge(years, months) {
            if (years === 0) {
              return months + (months === 1 ? " month" : " months");
            }
            if (months === 0) {
              return years + (years === 1 ? " year" : " years");
            }
            return years + "y " + months + "m";
          }

          function capitalise(value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
          }

          function createStat(label, value) {
            var item = document.createElement("div");
            item.className = "aav-stat";
            var key = document.createElement("div");
            key.className = "aav-stat-k";
            key.textContent = label;
            var output = document.createElement("div");
            output.className = "aav-stat-v";
            output.textContent = value;
            item.appendChild(key);
            item.appendChild(output);
            return item;
          }

          function selectedValues(name) {
            return Array.prototype.slice.call(form.querySelectorAll('input[name="' + name + '"]:checked')).map(function (input) {
              return input.value;
            });
          }

          function addPriority(list, level, label, title, copy) {
            list.push({ level: level, label: label, title: title, copy: copy });
          }

          function getPriorities(stage) {
            var priorities = [];
            var bcs = root.querySelector("#body-condition").value;
            var dental = root.querySelector("#dental-health").value;
            var mobility = root.querySelector("#mobility").value;
            var conditions = selectedValues("condition");
            var lifestyle = selectedValues("lifestyle");
            var isCat = state.species === "cat";

            if (dental === "severe") {
              addPriority(priorities, "soon", "Vet check soon", "Painful dental signs need assessment", "Loose teeth, swelling, pus or difficulty eating should not wait for a routine cleaning.");
            } else if (dental === "moderate") {
              addPriority(priorities, "plan", "Book a plan", "Arrange a dental assessment", "Heavy tartar and persistent bad breath commonly accompany periodontal disease and pain.");
            } else if (dental === "mild") {
              addPriority(priorities, "plan", "Act early", "Start a vet-approved dental plan", "Early dental care is easier and kinder than waiting for advanced disease.");
            } else if (dental === "healthy") {
              addPriority(priorities, "keep", "Keep doing", "Protect healthy teeth and gums", "Daily brushing is the most effective home-care option when your pet tolerates it.");
            }

            if (mobility === "limited") {
              addPriority(priorities, "soon", "Vet check soon", "Regular mobility difficulty deserves pain assessment", "Difficulty rising, walking or jumping may reflect pain even when a pet stays quiet.");
            } else if (mobility === "mild") {
              addPriority(priorities, "plan", "Discuss", "Review early stiffness", "Keep a short video and note when stiffness occurs so your veterinarian can assess the pattern.");
            }

            if (bcs === "obese" || bcs === "over") {
              addPriority(priorities, "plan", "Make a plan", "Set a measured weight target", "A calorie target, weighed portions and regular weigh-ins are safer than simply cutting food at random.");
            } else if (bcs === "under") {
              addPriority(priorities, "soon", "Check cause", "Investigate low body condition", "Low weight can reflect insufficient intake, dental pain, parasites or underlying disease.");
            } else if (bcs === "ideal") {
              addPriority(priorities, "keep", "Keep doing", "Maintain the waistline", "Measure meals and monitor weight so small changes are caught early.");
            }

            if (conditions.indexOf("kidney") !== -1) {
              addPriority(priorities, "plan", "Follow plan", "Keep kidney monitoring current", "Ask about weight, blood pressure, blood tests, urine tests, hydration and diet review intervals.");
            }
            if (conditions.indexOf("heart") !== -1) {
              addPriority(priorities, "plan", "Monitor", "Track resting breathing at home", "Record breaths per minute while fully asleep and report a sustained rise or any breathing effort promptly.");
            }
            if (conditions.indexOf("diabetes") !== -1) {
              addPriority(priorities, "plan", "Stay consistent", "Protect the diabetes routine", "Keep food, medication and monitoring consistent. Weakness, collapse or refusing food requires urgent advice.");
            }
            if (conditions.indexOf("thyroid") !== -1) {
              addPriority(priorities, "plan", "Recheck", "Keep thyroid monitoring on schedule", "Weight and follow-up blood tests help show whether control remains appropriate.");
            }
            if (conditions.indexOf("cancer") !== -1) {
              addPriority(priorities, "plan", "Follow plan", "Track comfort and treatment changes", "Log appetite, weight, breathing, mobility and good days so changes are easier to discuss.");
            }
            if (conditions.indexOf("liver") !== -1) {
              addPriority(priorities, "plan", "Recheck", "Keep liver follow-up current", "Follow the prescribed diet and medication plan, and report vomiting, reduced appetite, jaundice or behaviour changes.");
            }
            if (conditions.indexOf("gut") !== -1) {
              addPriority(priorities, "plan", "Track", "Log gut signs and weight", "Record vomiting, stool quality, appetite and weight using the same measures each time.");
            }
            if (conditions.indexOf("seizures") !== -1) {
              addPriority(priorities, "plan", "Track", "Keep a seizure log", "Record timing, duration, video if safe, medication and recovery. Cluster seizures or a prolonged seizure are emergencies.");
            }
            if (conditions.indexOf("cushings") !== -1) {
              addPriority(priorities, "plan", "Recheck", "Keep Cushing’s monitoring current", "Track thirst, urination, appetite, skin changes and medication timing between veterinary reviews.");
            }

            if (lifestyle.indexOf("smoke") !== -1) {
              addPriority(priorities, "plan", "Reduce exposure", "Create a smoke-free environment", "Avoid smoking or vaping around the pet, indoors, in vehicles or near bedding.");
            }
            if (lifestyle.indexOf("sedentary") !== -1) {
              addPriority(priorities, "plan", "Build gently", "Increase suitable daily movement", "Use short, regular sessions matched to mobility and medical conditions rather than sudden intense exercise.");
            }
            if (lifestyle.indexOf("diet") !== -1) {
              addPriority(priorities, "plan", "Review diet", "Check nutritional completeness", "Ask your veterinarian to confirm the diet is complete, balanced and suitable for this life stage and health history.");
            }
            if (lifestyle.indexOf("roaming") !== -1 && isCat) {
              addPriority(priorities, "plan", "Reduce risk", "Move toward controlled outdoor access", "An enclosure, secure garden or harness training can preserve enrichment while reducing trauma and infectious-disease risk.");
            }
            if (lifestyle.indexOf("active") !== -1) {
              addPriority(priorities, "keep", "Keep doing", "Continue exercise and enrichment", "Adjust intensity to age, weather, mobility and medical conditions.");
            }
            if (lifestyle.indexOf("vetcare") !== -1) {
              addPriority(priorities, "keep", "Keep doing", "Maintain regular veterinary and dental care", "Consistent records make small trends in weight, examination findings and test results easier to spot.");
            }
            if (lifestyle.indexOf("prevention") !== -1) {
              addPriority(priorities, "keep", "Keep doing", "Keep prevention current", "Vaccination and parasite plans should match local disease risk and lifestyle.");
            }

            if (priorities.length === 0) {
              if (stage.key === "senior") {
                addPriority(priorities, "plan", "Plan ahead", "Set a senior monitoring schedule", "More frequent examinations can catch weight, blood pressure, dental, mobility and organ changes earlier.");
              } else {
                addPriority(priorities, "keep", "Core care", "Keep prevention and weight records current", "Regular check-ups, a complete diet, dental care and a stable healthy weight do the heavy lifting.");
              }
            }

            var order = { soon: 0, plan: 1, keep: 2 };
            priorities.sort(function (a, b) {
              return order[a.level] - order[b.level];
            });
            return priorities;
          }

          function renderPriorities(priorities) {
            var list = root.querySelector("#priority-list");
            list.textContent = "";
            priorities.forEach(function (priority) {
              var item = document.createElement("li");
              item.className = "aav-priority";
              item.dataset.level = priority.level;

              var level = document.createElement("span");
              level.className = "aav-priority-level";
              level.textContent = priority.label;

              var copyWrap = document.createElement("div");
              var title = document.createElement("strong");
              title.textContent = priority.title;
              var copy = document.createElement("p");
              copy.textContent = priority.copy;

              copyWrap.appendChild(title);
              copyWrap.appendChild(copy);
              item.appendChild(level);
              item.appendChild(copyWrap);
              list.appendChild(item);
            });
          }

          function getCarePlan(stage, size, petName) {
            var pet = petName || "your pet";
            var isDog = state.species === "dog";
            var items = [];

            if (stage.key === "young") {
              items.push(["Build the foundations.", "Discuss vaccinations, parasite prevention, nutrition, socialisation, handling and species-appropriate desexing timing with your veterinarian."]);
              items.push(["Feed for controlled growth.", "Use a complete puppy or kitten diet and avoid overfeeding." + (isDog && (size === "large" || size === "giant") ? " Large-breed puppy nutrition is designed to support controlled skeletal growth." : "")]);
              items.push(["Make care normal.", "Practise gentle handling of paws, ears, mouth and body, paired with rewards, before those tasks become medically necessary."]);
            } else if (stage.key === "youngAdult") {
              items.push(["Protect the baseline.", "Keep routine examinations, locally appropriate vaccination and parasite prevention current."]);
              items.push(["Start dental home care now.", "A daily brushing routine is easier to build before periodontal disease becomes established."]);
              items.push(["Record normal.", "Log " + pet + "’s healthy weight, appetite, activity and behaviour so future changes stand out."]);
            } else if (stage.key === "mature") {
              items.push(["Watch the trends.", "Weight, muscle, dental health, drinking, urination, mobility, lumps and behaviour matter more than a single birthday."]);
              items.push(["Discuss screening.", "Ask which blood, urine or blood-pressure checks make sense for breed, age, history and examination findings."]);
              items.push(["Protect muscle and joints.", "Keep " + pet + " lean and active with exercise suited to fitness and any medical conditions."]);
            } else {
              items.push(["Plan more frequent reviews.", "Senior pets can change quickly. Discuss whether six-monthly examinations and targeted screening are appropriate."]);
              items.push(["Do not dismiss change as age.", "Weight loss, thirst, toileting changes, bad breath, stiffness, coughing, confusion or appetite changes deserve assessment."]);
              items.push(["Design for comfort.", "Use warm bedding, traction, ramps or steps, accessible food and water, and pain management where prescribed."]);
              if (!isDog) {
                items.push(["Make cat care easy.", "Provide low-entry litter trays, several water stations, warm resting places and resources that do not require difficult jumps."]);
              }
            }

            return items;
          }

          function renderCarePlan(items, stage) {
            var title = root.querySelector("#care-title");
            title.textContent = "Care plan for a " + stage.name.toLowerCase();
            var list = root.querySelector("#care-list");
            list.textContent = "";
            items.forEach(function (item) {
              var li = document.createElement("li");
              var strong = document.createElement("strong");
              strong.textContent = item[0] + " ";
              li.appendChild(strong);
              li.appendChild(document.createTextNode(item[1]));
              list.appendChild(li);
            });
          }

          function drawChart(age, humanAge, size) {
            var anchors = state.species === "dog" ? DOG_ANCHORS[size] : CAT_ANCHORS;
            var maxAge = Math.max(state.species === "dog" ? 16 : 20, Math.ceil(age) + 1);
            var width = 700;
            var height = 310;
            var left = 50;
            var right = 20;
            var top = 20;
            var bottom = 45;
            var maxHuman = interpolate(anchors, maxAge);
            var yMax = Math.max(80, Math.ceil(maxHuman / 20) * 20);

            function x(value) {
              return left + (value / maxAge) * (width - left - right);
            }

            function y(value) {
              return height - bottom - (value / yMax) * (height - top - bottom);
            }

            var grid = "";
            var gridValue;
            for (gridValue = 0; gridValue <= yMax; gridValue += 20) {
              grid += '<line x1="' + left + '" y1="' + y(gridValue).toFixed(1) + '" x2="' + (width - right) + '" y2="' + y(gridValue).toFixed(1) + '" stroke="#eeeaf5" stroke-width="1"/>';
              grid += '<text x="' + (left - 9) + '" y="' + (y(gridValue) + 4).toFixed(1) + '" text-anchor="end" font-size="11" fill="#6f6a86">' + gridValue + "</text>";
            }

            var xTicks = "";
            var xStep = maxAge > 18 ? 4 : 2;
            var xValue;
            for (xValue = 0; xValue <= maxAge; xValue += xStep) {
              xTicks += '<text x="' + x(xValue).toFixed(1) + '" y="' + (height - bottom + 20) + '" text-anchor="middle" font-size="11" fill="#6f6a86">' + xValue + "</text>";
            }

            var points = [];
            var currentAge;
            for (currentAge = 0; currentAge <= maxAge; currentAge += 0.25) {
              points.push([x(currentAge), y(interpolate(anchors, currentAge))]);
            }
            var path = points.map(function (point, index) {
              return (index === 0 ? "M" : "L") + point[0].toFixed(1) + " " + point[1].toFixed(1);
            }).join(" ");

            var currentX = x(age);
            var currentY = y(humanAge);
            var labelX = currentX > width - 135 ? currentX - 105 : currentX + 12;
            var labelY = Math.max(6, currentY - 39);
            var chartDescription = (state.species === "dog" ? SIZE_LABELS[size].toLowerCase() + " dog" : "cat") + " age curve. The entered age of " + Math.round(age * 10) / 10 + " years corresponds to about " + Math.round(humanAge) + " human years.";

            var svg = '';
            svg += '<svg viewBox="0 0 ' + width + " " + height + '" role="img" aria-labelledby="age-chart-title age-chart-desc" xmlns="http://www.w3.org/2000/svg">';
            svg += '<title id="age-chart-title">Illustrative pet age curve</title>';
            svg += '<desc id="age-chart-desc">' + chartDescription + "</desc>";
            svg += grid + xTicks;
            svg += '<path d="' + path + '" fill="none" stroke="#8637B2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>';
            svg += '<line x1="' + currentX.toFixed(1) + '" y1="' + currentY.toFixed(1) + '" x2="' + currentX.toFixed(1) + '" y2="' + y(0).toFixed(1) + '" stroke="#101123" stroke-width="1.5" stroke-dasharray="5 5"/>';
            svg += '<circle cx="' + currentX.toFixed(1) + '" cy="' + currentY.toFixed(1) + '" r="8" fill="#ffffff" stroke="#101123" stroke-width="4"/>';
            svg += '<rect x="' + labelX.toFixed(1) + '" y="' + labelY.toFixed(1) + '" width="94" height="30" rx="5" fill="#101123"/>';
            svg += '<text x="' + (labelX + 47).toFixed(1) + '" y="' + (labelY + 20).toFixed(1) + '" text-anchor="middle" font-size="12" font-weight="800" fill="#ffffff">Today ≈ ' + Math.round(humanAge) + "</text>";
            svg += '<text x="' + (width / 2) + '" y="' + (height - 5) + '" text-anchor="middle" font-size="11" fill="#6f6a86">' + (state.species === "dog" ? "Dog" : "Cat") + " years (chronological age)</text>";
            svg += '<text x="14" y="' + (height / 2) + '" text-anchor="middle" font-size="11" fill="#6f6a86" transform="rotate(-90 14 ' + (height / 2) + ')">Human-age analogy</text>';
            svg += "</svg>";

            var chartHost = root.querySelector("#chart-host");
            chartHost.innerHTML = svg;
            window.requestAnimationFrame(function () {
              if (chartHost.scrollWidth > chartHost.clientWidth) {
                var scaledPoint = (currentX / width) * chartHost.scrollWidth;
                chartHost.scrollLeft = Math.max(0, scaledPoint - chartHost.clientWidth / 2);
              }
            });
            root.querySelector("#curve-copy").textContent = state.species === "dog"
              ? "This shows how the commonly used " + SIZE_LABELS[size].toLowerCase() + "-dog comparison rises with chronological age."
              : "This shows how the commonly used feline comparison rises with chronological age.";
          }

          function buildSummary(data, humanAge, stage, priorities) {
            var name = root.querySelector("#pet-name").value.trim();
            var subject = name || (state.species === "dog" ? "Dog" : "Cat");
            var lines = [
              "ASK A VET™ — Dog & Cat Human Years Calculator",
              "",
              subject + "’s chronological age: " + formatAge(data.years, data.months),
              "Rough human-age equivalent: " + Math.round(humanAge) + " human years",
              "Life stage: " + stage.name
            ];
            if (state.species === "dog") {
              lines.push("Expected healthy adult size: " + SIZE_LABELS[data.size]);
            }
            lines.push("", "Healthy-ageing priorities:");
            priorities.slice(0, 6).forEach(function (priority) {
              lines.push("• " + priority.title + " — " + priority.copy);
            });
            lines.push(
              "",
              "This is an educational age analogy, not a biological-age test, diagnosis, prognosis or lifespan prediction.",
              "https://askavet.com/pages/human-years-calculator",
              "",
              "By Dr Duncan Houston, BVSc · ASK A VET™"
            );
            return lines.join("\n");
          }

          function renderSizeNotice(data) {
            var notice = root.querySelector("#size-notice");
            var messages = [];
            notice.hidden = true;
            notice.textContent = "";

            if (state.species === "dog" && data.age > 16) {
              messages.push("Older-age note: the main size-banded dog chart ends at 16 years. This result continues the final interval and is therefore more uncertain.");
            }
            if (state.species === "cat" && data.age > 20) {
              messages.push("Older-age note: feline comparisons above 20 years are increasingly approximate, even when a chart lists older anchors.");
            }

            if (state.species === "dog" && data.weight !== null) {
              var kg = weightToKg(data.weight);
              var weightSize = sizeFromWeight(kg);
              if (weightSize !== data.size) {
                var entered = Math.round(data.weight * 10) / 10;
                messages.push("Size check: " + entered + " " + state.unit + " usually falls in the " + SIZE_LABELS[weightSize].toLowerCase() + " band, while " + SIZE_LABELS[data.size].toLowerCase() + " is selected. Use expected healthy adult frame size; excess weight should not move a dog into a larger band.");
              }
            }

            if (messages.length) {
              notice.textContent = messages.join(" ");
              notice.hidden = false;
            }
          }

          function renderResult(data) {
            var anchors = state.species === "dog" ? DOG_ANCHORS[data.size] : CAT_ANCHORS;
            var humanAge = interpolate(anchors, data.age);
            var roundedAge = Math.round(humanAge);
            var stage = getLifeStage(data.age, data.size);
            var name = root.querySelector("#pet-name").value.trim();
            var displayName = name || (state.species === "dog" ? "your dog" : "your cat");
            var priorities = getPriorities(stage);
            var carePlan = getCarePlan(stage, data.size, name);

            root.querySelector("#result-age").textContent = String(roundedAge);
            root.querySelector("#result-heading").textContent = name ? name + " is roughly " + roundedAge + " in human terms" : "Your pet is roughly " + roundedAge + " in human terms";
            root.querySelector("#result-context").textContent = "At " + formatAge(data.years, data.months) + ", " + displayName + " sits around this point on the commonly used " + (state.species === "dog" ? SIZE_LABELS[data.size].toLowerCase() + "-dog" : "feline") + " age comparison.";
            root.querySelector("#result-stage").textContent = stage.name + " life stage";

            var stats = root.querySelector("#result-stats");
            stats.textContent = "";
            stats.appendChild(createStat("Chronological age", formatAge(data.years, data.months)));
            stats.appendChild(createStat("Life stage", stage.name));
            if (state.species === "dog") {
              stats.appendChild(createStat("Adult size band", SIZE_LABELS[data.size]));
            } else {
              stats.appendChild(createStat("Conversion model", "Feline curve"));
            }

            renderSizeNotice(data);
            renderPriorities(priorities);
            drawChart(data.age, humanAge, data.size);
            renderCarePlan(carePlan, stage);

            state.resultSummary = buildSummary(data, humanAge, stage, priorities);
            state.hasResult = true;
            dirtyBox.hidden = true;
            resultActionButtons.forEach(function (button) {
              button.disabled = false;
            });
            actionStatus.textContent = "";
            results.hidden = false;
            results.focus({ preventScroll: true });
            results.scrollIntoView({ behavior: "smooth", block: "start" });
          }

          function markDirty() {
            if (!state.hasResult || results.hidden) {
              return;
            }
            dirtyBox.hidden = false;
            resultActionButtons.forEach(function (button) {
              button.disabled = true;
            });
            actionStatus.textContent = "";
          }

          function copyText(text) {
            if (navigator.clipboard && window.isSecureContext) {
              return navigator.clipboard.writeText(text);
            }
            return new Promise(function (resolve, reject) {
              var textarea = document.createElement("textarea");
              textarea.value = text;
              textarea.setAttribute("readonly", "");
              textarea.style.position = "fixed";
              textarea.style.opacity = "0";
              document.body.appendChild(textarea);
              textarea.select();
              try {
                var successful = document.execCommand("copy");
                document.body.removeChild(textarea);
                successful ? resolve() : reject(new Error("Copy failed"));
              } catch (error) {
                document.body.removeChild(textarea);
                reject(error);
              }
            });
          }

          function startAgain() {
            form.reset();
            state.unit = "kg";
            unitButtons.forEach(function (button) {
              button.setAttribute("aria-pressed", String(button.dataset.unit === "kg"));
            });
            weightInput.max = "250";
            weightInput.placeholder = "e.g. 28";
            sizeSelect.value = "";
            setSpecies("dog", false);
            clearError();
            results.hidden = true;
            dirtyBox.hidden = true;
            state.hasResult = false;
            state.resultSummary = "";
            actionStatus.textContent = "";
            personaliseToggle.setAttribute("aria-expanded", "false");
            personalisePanel.hidden = true;
            personaliseSymbol.textContent = "+";
            root.querySelector("#calculator").scrollIntoView({ behavior: "smooth", block: "start" });
            speciesButtons[0].focus({ preventScroll: true });
          }

          speciesButtons.forEach(function (button) {
            button.addEventListener("click", function () {
              setSpecies(button.dataset.species, true);
            });
          });

          unitButtons.forEach(function (button) {
            button.addEventListener("click", function () {
              setUnit(button.dataset.unit, true);
            });
          });

          personaliseToggle.addEventListener("click", function () {
            var willOpen = personaliseToggle.getAttribute("aria-expanded") !== "true";
            personaliseToggle.setAttribute("aria-expanded", String(willOpen));
            personalisePanel.hidden = !willOpen;
            personaliseSymbol.textContent = willOpen ? "−" : "+";
            if (willOpen) {
              root.querySelector("#step-3-title").focus({ preventScroll: true });
            }
          });

          breedSelect.addEventListener("change", function () {
            var option = breedSelect.options[breedSelect.selectedIndex];
            if (option && option.dataset.size) {
              sizeSelect.value = option.dataset.size;
            }
            markDirty();
          });

          form.addEventListener("input", function (event) {
            markDirty();
          });

          form.addEventListener("change", function (event) {
            if (event.target.name === "lifestyle" && event.target.checked) {
              if (event.target.value === "active") {
                var sedentary = form.querySelector('input[name="lifestyle"][value="sedentary"]');
                if (sedentary) {
                  sedentary.checked = false;
                }
              } else if (event.target.value === "sedentary") {
                var active = form.querySelector('input[name="lifestyle"][value="active"]');
                if (active) {
                  active.checked = false;
                }
              }
            }
            markDirty();
          });

          form.addEventListener("submit", function (event) {
            event.preventDefault();
            clearError();
            var data = validateInputs();
            if (data.error) {
              showError(data.error, data.field);
              return;
            }
            renderResult(data);
          });

          root.querySelector("#copy-result").addEventListener("click", function () {
            copyText(state.resultSummary).then(function () {
              actionStatus.textContent = "Result copied.";
            }).catch(function () {
              actionStatus.textContent = "Copy was blocked by this browser. Select the result and copy it manually.";
            });
          });

          root.querySelector("#email-result").addEventListener("click", function () {
            var petName = root.querySelector("#pet-name").value.trim();
            var subject = (petName ? petName + "’s" : "My pet’s") + " age result from ASK A VET™";
            window.location.href = "mailto:?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(state.resultSummary);
          });

          root.querySelector("#print-result").addEventListener("click", function () {
            window.print();
          });

          root.querySelector("#start-again").addEventListener("click", startAgain);

          addBreedOptions();
          setSpecies("dog", false);
  
    }
  }
  customElements.define(ELEMENT_NAME, HumanYearsCalculator);
})();
